import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import TransportFileLine from '../entities/transportfileline';
import Util from '@/lib/util';
import appconst from './../../lib/appconst';

interface TransportFileState extends ListState<TransportFileLine> {
    itemsImported: Array<TransportFileLine>,
    countItems : number,
    countImportedItems: number
}
class TransportFileModule extends ListModule<TransportFileState, any, TransportFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<TransportFileLine>(),
        loading: false,
        itemsImported: new Array<TransportFileLine>(),
        countItems:0,
        countImportedItems:0
    }
    actions = {
        async getAll(context: ActionContext<TransportFileState, any>, payload: any) {
            context.state.totalCount = context.state.itemsImported.length;
        },
        async uploadImportTransportFile(context: ActionContext<TransportFileState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/TransportFile/ImportTransports', data);
            return reponse.data.result
        },
        async export(context:ActionContext<TransportFileState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportTransports/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: TransportFileState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TransportFileState, pagesize: number) {
            state.pageSize = pagesize;
        },
        processNotifier(state: TransportFileState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let transportLine = payload.data.data as TransportFileLine;
                    state.itemsImported.unshift(transportLine);
                }
                if (payload.data.countItems != undefined && payload.data.countItems != null && payload.data.countItems > 0) {
                    state.countItems = payload.data.countItems as number;
                }
                if (payload.data.countImportedItems != undefined && payload.data.countImportedItems != null && payload.data.countImportedItems> 0) {
                    state.countImportedItems = payload.data.countImportedItems as number;
                }
            }

        },
        resetList(state: TransportFileState) {
            state.itemsImported = new Array<TransportFileLine>();
        } ,
        pageChangeItemsImported(state: TransportFileState) {
            state.list = Util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const transportFileModule = new TransportFileModule();
export default transportFileModule;